"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
exports.__esModule = true;
exports.TagFacet = void 0;
var __1 = require("./../");
var TagFacet = /** @class */ (function (_super) {
    __extends(TagFacet, _super);
    function TagFacet(params) {
        var _this = _super.call(this, params) || this;
        var restrictByProducts = params.restrictByProducts, restrictByCollection = params.restrictByCollection;
        _this.restrictByProducts = typeof restrictByProducts === typeof undefined ? false : restrictByProducts; //If true, only tags that are in the currently filtered products will show
        _this.restrictByCollection = typeof restrictByCollection === typeof undefined ? true : restrictByCollection; //If true only tags that are in the collection will show
        return _this;
    }
    TagFacet.prototype.getVisibleOptions = function () {
        var _this = this;
        var allOptions = _super.prototype.getVisibleOptions ? _super.prototype.getVisibleOptions.call(this) : null;
        var productTags;
        var collectionTags = __spreadArray([], this.template.data.allTags);
        if (!allOptions || !allOptions.length)
            allOptions = collectionTags;
        if (this.restrictByProducts && this.template.draw.unpaginatedProducts) {
            productTags = this.collection.draw.unpaginatedProducts.reduce(function (tags, v) {
                var p = v.product;
                return __spreadArray(__spreadArray([], tags), p.tags);
            }, []);
            //Remove duplicates
            productTags = productTags.filter(function (t, i) { return productTags.indexOf(t) === i; });
        }
        return allOptions.filter(function (tag) {
            //Always show checked filters, so that they may be unchecked
            if (_this.isSelected(tag))
                return true;
            if (_this.restrictByCollection && collectionTags.indexOf(tag) === -1)
                return false;
            if (_this.restrictByProducts && productTags.indexOf(tag) === -1)
                return false;
            return true;
        });
    };
    TagFacet.prototype.getOptions = function () {
        var _this = this;
        //Add all tags for all products
        var options = this.template.data.products.reduce(function (x, product) {
            if (!_this.template.data.isProductInCollection(product))
                return x;
            return x = __spreadArray(__spreadArray([], x), product.tags);
        }, []);
        //Remove duplicates
        return options.filter(function (o, i) { return options.indexOf(o) === i; });
    };
    return TagFacet;
}(__1.Facet));
exports.TagFacet = TagFacet;
//# sourceMappingURL=TagFacet.js.map